// extracted by mini-css-extract-plugin
export default {"fieldRoot":"FieldDateInput_fieldRoot__h8NNB","mobileMargins":"FieldDateInput_mobileMargins__gUv4A","required":"FieldDateInput_required__duKow"};